import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { makeStyles, createStyles } from '../../styles';
export const PaperModalBody = ({ className, children, }) => {
    const classes = useStyles();
    return _jsx("div", Object.assign({ className: cn(classes.root, className) }, { children: children }));
};
const useStyles = makeStyles((theme) => createStyles({
    root: {
        padding: theme.spacing(1, 4),
        '&:first-child': {
            paddingTop: theme.spacing(4),
        },
        '&:last-child': {
            paddingBottom: theme.spacing(4),
        },
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2),
        },
    },
}));
export default PaperModalBody;
//# sourceMappingURL=PaperModalBody.js.map